import React, { createContext, useContext, useState } from "react";

// Import translations
import landingTranslations from "../translation/landing.json";
import aboutTranslations from "../translation/about.json";
import resourcesTranslations from "../translation/resources.json";
import privacyPolicyTranslations from "../translation/privacyPolicyTranslations.json";
import cookiePolicyTranslations from "../translation/cookiePolicyTranslations.json";
import carbon2024Translations from "../translation/CarbonReduction2024.json";
import careersTranslations from "../translation/careers.json";
import helpBannerTranslations from "../translation/helpBanner.json";
import salesTranslations from "../translation/sales.json";
import { vacanciesTranslations } from "../translation/vacanciesTranslations";

const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

const supportedLanguages = ["en", "fr", "de", "es"];

const getInitialLanguage = () => {
  const storedLang = localStorage.getItem("preferredLanguage");
  if (storedLang && supportedLanguages.includes(storedLang)) {
    return storedLang;
  }

  const browserLang = navigator.language.slice(0, 2);
  return supportedLanguages.includes(browserLang) ? browserLang : "en";
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(getInitialLanguage());

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
    localStorage.setItem("preferredLanguage", language);
  };

  const translations = {
    landing: landingTranslations,
    helpBanner: helpBannerTranslations,
    about: aboutTranslations,
    resources: resourcesTranslations,
    policy: privacyPolicyTranslations,
    cookies: cookiePolicyTranslations,
    carbon2024: carbon2024Translations,
    careers: careersTranslations,
    sales: salesTranslations,
    vacancies: vacanciesTranslations,
  };

  return (
    <LanguageContext.Provider
      value={{ currentLanguage, handleLanguageChange, translations }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
